module.exports = __webpack_public_path__ + "assets/img/btn-view-6e2439ba.png";